/**
 * 動画スライドの切替タブ。slides.length > 1 のときのみ表示する。
 */
import type { AdImageSlide } from '@goenhub/shared';

interface Props {
  slides: AdImageSlide[];
  activeId: string | null;
  onSelect: (id: string) => void;
}

export function SlideTabs({ slides, activeId, onSelect }: Props) {
  return (
    <div className="flex border-b border-[var(--border)] bg-[var(--bg-elevated)]">
      {slides.map((s, i) => (
        <button
          key={s.id}
          type="button"
          onClick={() => onSelect(s.id)}
          className={`px-4 py-2 text-xs border-r border-[var(--border)] ${
            activeId === s.id
              ? 'bg-[var(--bg-root)] text-[var(--text-primary)] font-medium'
              : 'text-[var(--text-muted)] hover:bg-[var(--bg-hover)]'
          }`}
        >
          {i + 1}
        </button>
      ))}
    </div>
  );
}
